import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Container, Row, Col } from 'reactstrap';

import code from './img/new/code.png';
import design from './img/new/design.png';
import features from './img/new/features.png';
import settings from './img/new/settings.png';
import support from './img/new/support.png';
import tools from './img/new/tools.png';

class Services extends React.Component {
  render() {
    const {
      styles: s,
    } = this.props;
    return (
      <div id="services">
        <section className={cx(s.newServiceArea, s.bgColorThree)}>
          <Container>
            <div className={cx(s.sectionTitleThree, s.titleGr, s.mb60)}>
              <h2>OUR <span>Solutions</span></h2>
            </div>
            <Row>
              <Col md="4" xs="12" className={s.sfb}>
                <div className={cx(s.serviceFlipbox, s.serviceFlipboxTwo)}>
                  <div className={s.flipboxFont}>
                    <div className={s.innerFlip}>
                      <img src={code} alt="" />
                      <h4>Role-wise success profiles</h4>
                    </div>
                  </div>
                  <div className={s.flipboxBack}>
                    <div className={s.innerFlip}>
                      <p>This is the output of Industry Benchmarking activity and gives the technical and Behavioral skill requirements by unique job roles. The uniqueness is that the Spotmentor engine keeps on scanning the evolving skill requirements and updating the dashboard to deliver a Real time benchmarking for all the organizational job roles.</p>
                      {/* <a>Learn More</a> */}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="4" xs="12" className={s.sfb}>
                <div className={cx(s.serviceFlipbox, s.serviceFlipboxTwo)}>
                  <div className={s.flipboxFont}>
                    <div className={s.innerFlip}>
                      <img src={design} alt="" />
                      <h4>Emerging skills</h4>
                    </div>
                  </div>
                  <div className={s.flipboxBack}>
                    <div className={s.innerFlip}>
                      <p>This dashboard identifies emerging skills and their impact on the job roles and the employees of the organization and its competitors. This can help in recalibrating job descriptions, reskilling plans and upskilling plans.</p>
                      {/* <a>Learn More</a> */}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="4" xs="12" className={s.sfb}>
                <div className={cx(s.serviceFlipbox, s.serviceFlipboxTwo)}>
                  <div className={s.flipboxFont}>
                    <div className={s.innerFlip}>
                      <img src={features} alt="" />
                      <h4>Organisational skill inventory</h4>
                    </div>
                  </div>
                  <div className={s.flipboxBack}>
                    <div className={s.innerFlip}>
                      <p>This dashboard presents the set of all skills and respective proficiencies present in an organization. This also gives an employee-wise view of technical and behavioral skills and respective proficiencies, which are monitored in real time to reflect upskilling too.</p>
                      {/* <a>Learn More</a> */}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="4" xs="12" className={s.sfb}>
                <div className={cx(s.serviceFlipbox, s.serviceFlipboxTwo)}>
                  <div className={s.flipboxFont}>
                    <div className={s.innerFlip}>
                      <img src={settings} alt="" />
                      <h4>Indexed catalogs</h4>
                    </div>
                  </div>
                  <div className={s.flipboxBack}>
                    <div className={s.innerFlip}>
                      <p>Learning content from multiple sources is analyzed and indexed with subjects, keywords and sources. This gives automatically curated, organised and skills-specific content catalogs.</p>
                      {/* <a>Learn More</a> */}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="4" xs="12" className={s.sfb}>
                <div className={cx(s.serviceFlipbox, s.serviceFlipboxTwo)}>
                  <div className={s.flipboxFont}>
                    <div className={s.innerFlip}>
                      <img src={support} alt="" />
                      <h4>Hyper-personalised learning plans</h4>
                    </div>
                  </div>
                  <div className={s.flipboxBack}>
                    <div className={s.innerFlip}>
                      <p>The only learning plans which take into account organisation’s needs as well employee attributes to deliver the most targeted and SMART learning plans. These use more than 100 different variables in real time. Some of the variables which are used are role specific skill gaps, emerging skills in the marketplace, employee aspirations, content engagement, peer performance etc.</p>
                      {/* <a>Learn More</a> */}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="4" xs="12" className={s.sfb}>
                <div className={cx(s.serviceFlipbox, s.serviceFlipboxTwo)}>
                  <div className={s.flipboxFont}>
                    <div className={s.innerFlip}>
                      <img src={tools} alt="" />
                      <h4>Business impact</h4>
                    </div>
                  </div>
                  <div className={s.flipboxBack}>
                    <div className={s.innerFlip}>
                      <p>A single snapshot that connects important business metrics, employee goals, and learning programs to tell what tangible business improvements are happening due to skilling initiatives. You can use it for strategizing, convincing stakeholders, budgeting etc.</p>
                      {/* <a>Learn More</a> */}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/routes/home/Services.js